var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHelp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 10.5C0 4.97715 4.47715 0.5 10 0.5C15.5229 0.5 20 4.97715 20 10.5C20 16.0229 15.5229 20.5 10 20.5C4.47715 20.5 0 16.0229 0 10.5ZM9.06977 14.686C9.06977 14.1723 9.48623 13.7558 10 13.7558H10.0084C10.5221 13.7558 10.9386 14.1723 10.9386 14.686C10.9386 15.1998 10.5221 15.6163 10.0084 15.6163H10C9.48623 15.6163 9.06977 15.1998 9.06977 14.686ZM9.06977 8.17442C9.06977 7.66067 9.48623 7.24419 10 7.24419C10.5138 7.24419 10.9302 7.66067 10.9302 8.17442C10.9302 8.361 10.8763 8.53213 10.7834 8.67647C10.6736 8.84716 10.5339 9.02716 10.3618 9.24102L10.2784 9.34428C10.134 9.5227 9.97088 9.72465 9.82214 9.92902C9.47237 10.4098 9.06977 11.0753 9.06977 11.8953C9.06977 12.4091 9.48623 12.8256 10 12.8256C10.5138 12.8256 10.9302 12.4091 10.9302 11.8953C10.9302 11.6879 11.0325 11.4277 11.3265 11.0236C11.4448 10.861 11.5725 10.703 11.7162 10.5251L11.8113 10.4073C11.9848 10.1915 12.1798 9.94446 12.348 9.68316C12.6282 9.24763 12.7907 8.72856 12.7907 8.17442C12.7907 6.63316 11.5413 5.38372 10 5.38372C8.4587 5.38372 7.2093 6.63316 7.2093 8.17442C7.2093 8.68819 7.62578 9.10465 8.13953 9.10465C8.6533 9.10465 9.06977 8.68819 9.06977 8.17442Z",
    fill: "#44546F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelp);
export default __webpack_public_path__ + "static/media/help.295ac294a094d02e0c731898e5984493.svg";
export { ForwardRef as ReactComponent };